import { useEffect, useState,useContext } from "react"
import { Button } from "@mui/material";
import styles from "./Products.module.css"
import { Link, useNavigate } from "react-router-dom"
import { productData } from "../Constant/ConstantRegister"
import { baseUrl } from "../../url";
import { AuthContext, AuthContextType } from "../../Auth";

export default function Products() {

    const navigate = useNavigate();

    const [selectManufacture, setSelectManufacture] = useState<string[]>([]);
    const [selectedManufacture, setSelectedManufacture] = useState<string>("");
    const [products, setProducts] = useState<productData[]>([]);
    const { setAuth } = useContext(AuthContext) as AuthContextType;
    const [reload, setReload]= useState<boolean>(false);

     useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch(`${baseUrl}/checkAuth`, {
                    method: "POST",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                });
                const data = await response.json();
                if (!data.result) {
                    console.log("Not authenticated");
                    setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
                    return navigate("/login");
                }
                 const response2 = await fetch(`${baseUrl}/getusersdata`,{
                        method: "POST",
                        credentials: "include",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ username: data.username })
                    })
                    const data2 = await response2.json();
                    console.log("Authenticated user:", data.username, "Office:", data2.office,"Authority:",data2.authority);
                    setAuth({ username: data.username, isAuthenticated: true, office: data2.office,authority:data2.authority });
            } catch (error) {
                console.error(error);
            }
        }
        checkAuth();
    }, [navigate, setAuth]);

    useEffect(() => {
        const fetchSelectInit = async () => {
            const response = await fetch(`${baseUrl}/getmanufacture`,{
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            if(data.isAuth===false){
            return }
            const Manufactures: string[] = data.manufacture.map((item: Object) => Object.values(item))
            setSelectManufacture(Manufactures);
        }
        fetchSelectInit();

    }, [ navigate, setAuth])

    useEffect(() => {

        const fetchProducts = async () => {
            const response = await fetch(`${baseUrl}/getproducts`, {
                method: "POST",
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "manufacture": selectedManufacture })
            })
            const data = await response.json();
            if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined , authority:"user"});
            return navigate("/login");}
            let newProducts = [];
            for (let i = 0; data.length > i; i++) {
                const newData = JSON.parse(data[i].specification);
                console.log(newData);
                const newProduct: productData = {
                    product_id: data[i].product_id,
                    productname: data[i].productname,
                    manufacture: data[i].manufacture,
                    moldingsite: data[i].moldingsite,
                    supplier: data[i].supplier,
                    cost: data[i].cost,
                    leftright: newData.leftright,
                    size: newData.size,
                    color: newData.color,
                    product_type: data[i].product_type,
                    base_price: data[i].base_price
                }
                newProducts.push(newProduct);
            }
            setProducts(newProducts);
        }

        fetchProducts();
    }, [selectedManufacture, navigate, setAuth,reload]);


    const handleManufacture = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedManufacture(e.target.value);
    }

    const handleEdit = (index: number) => {
        const editProduct = products[index];
        console.log(editProduct);
        navigate("/ProductEditor", { state: editProduct });
    }

    const handleDelete = async (index: number) => {
        const deleteproduct_id = products[index].product_id;
        const deleteproductname = products[index].productname;
        if (window.confirm(`${deleteproductname}を削除します。よろしいですか？`)) {
            try {
                const response = await fetch(`${baseUrl}/deleteproduct`, {
                    method: "DELETE",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ "deleteproduct_id": deleteproduct_id })
                })
                const data = await response.json();
                if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
                if (!response.ok) {
                    throw new Error("Network response was not OK");
                }
                alert("削除に成功しました。");
                setReload(!reload);
            } catch (error) {
                console.error(error);
            }
        } else {
            alert("削除をキャンセルしました。")
        }
    }

    const typeIndicator = (type: string)=>{
        if(type==="list") return "リスト内既製品"
        if(type==="readymade") return "リスト外既製品"
        if(type==="not_applicable") return "保険適用外（自費）製品"
    }

    return (
        <div className={styles.div}>
            <h2 className={styles.h2}>製品リスト</h2>
            <Link to="/ProductRegister"><Button variant="contained" size="large" sx={{ position: "absolute", top: 25, right: 50, fontSize: 16, "@media screen and (max-width:959px)": { top: 60, right: 10 } }} >製品を新規登録する</Button></Link>
            <select name="selectManufacture" value={selectedManufacture} onChange={handleManufacture} className={styles.select}>
                <option value="" hidden>メーカー</option>
                {selectManufacture.map((item, index) => (
                    <option key={index} value={item}>{item}</option>))}
            </select>
            <div className={styles.scroll}>
                {(products.length > 0) ? (<table className={styles.table}>
                    <thead><tr><th className={styles.th}>製品名</th><th className={styles.th}>値段</th><th className={styles.th}>採型区分</th><th className={styles.th}>左右</th><th className={styles.th}>サイズ</th><th className={styles.th}>色</th><th className={styles.th}>製品タイプ</th><th className={styles.th}>基準価格</th></tr></thead>
                    <tbody>
                        {products.map((item, index) => (
                            <tr key={index} className={styles.tr}><td className={styles.td}>{item.productname}</td><td className={styles.td}>{item.cost}</td><td className={styles.td}>{item.moldingsite}</td><td className={styles.td}>{item.leftright.map((item2, index2) => (<div key={index2}>{item2}</div>))}</td><td className={styles.td}>{item.size.map((item2, index3) => <div key={index3}>{item2}</div>)}</td><td className={styles.td}>{item.color.map((item2, index4) => (<div key={index4}>{item2}</div>))}</td><td className={styles.td}>{typeIndicator(item.product_type)}</td><td className={styles.td}>{item.base_price}</td><td className={styles.td2}><Button onClick={() => handleEdit(index)}size="small">編集</Button><Button onClick={() => handleDelete(index)} size="small">削除</Button></td></tr>
                        ))}
                    </tbody>
                </table>) : <p className={styles.p}>メーカーを選択してください。</p>}
            </div>
        </div>
    )
}